module.exports = "<div>\r\n  <iframe src=\"{{document.documentPath}}\"></iframe>\r\n</div>\r\n"